interface Consts {
  METALOCATOR_ID: number;
  DEFAULT_LOCALE: string;
  LABLOCATOR_BASE_URL: string;
  ITERO_REDIRECT: {
    ITERO_BASE_URL: string;
    REDIRECT_ROUTES: Record<"/" | "/register" | "/results", string>;
  };
}

const ITERO_DEVELOPMENT_HOST = "http://localhost:4528/";
const ITERO_STAGING_HOST = "https://cws-itero-replatforming-qas.herokuapp.com/";
const ITERO_PROD_HOST = "https://itero.com";
const ITERO_BASE_URL =
  process.env.ENVIRONMENT === "development"
    ? ITERO_DEVELOPMENT_HOST
    : process.env.ENVIRONMENT === "test"
    ? ITERO_STAGING_HOST
    : ITERO_PROD_HOST;

const consts: Consts = {
  METALOCATOR_ID: 15063,
  DEFAULT_LOCALE: "en-US",
  LABLOCATOR_BASE_URL: "https://lablocator.itero.com/",
  ITERO_REDIRECT: {
    ITERO_BASE_URL,
    REDIRECT_ROUTES: {
      "/": "/lab-locator",

      "/register": "/lab-locator/register",

      "/results": "/",
    },
  },
};

export default consts;
